import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { Auth } from 'aws-amplify';
import { UserService } from '@core/api/user.service';

export interface OTPDialogData {
  email?: string;
  mode: 'sms-verify' | 'verify-phone' | 'authenticate';
  password?: string;
  user?: CognitoUser;
  verificationCodeSent?: boolean;
  phone?: string;
}

@Component({
  selector: 'fc-otp-dialog',
  styleUrls: ['./otp-dialog.component.scss'],
  templateUrl: 'otp-dialog.component.html',
  standalone: false
})
export class OtpDialogComponent implements OnInit {
  email?: string;
  errorMessage?: string;
  mode: 'sms-verify' | 'verify-phone' | 'authenticate';
  otpForm: FormGroup = this.formBuilder.group({
    otp: new FormControl(null, [Validators.required, Validators.minLength(6), Validators.maxLength(6)]),
  });
  password?: string;
  user?: CognitoUser;
  verificationCodeSent: boolean;

  constructor(
    readonly dialogRef: MatDialogRef<OtpDialogComponent>,
    readonly formBuilder: FormBuilder,
    readonly userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: OTPDialogData
  ) {
    this.email = data.email;
    this.mode = data.mode;
    this.password = data.password;
    this.user = data.user;
    this.verificationCodeSent = data.verificationCodeSent ? data.verificationCodeSent : false;
  }

  ngOnInit() {
    if (this.mode === 'verify-phone' || this.mode === 'sms-verify') {
      this.sendOtp();
    }
  }

  sendOtp(): void {
    if (this.mode === 'verify-phone') {
      Auth.verifyCurrentUserAttribute('phone_number').then(
        () => {
          this.verificationCodeSent = true;
        },
        error => {
          this.errorMessage = error.message;
          console.log(error);
        }
      );
    } else if (this.mode === 'authenticate' && this.email && this.password) {
      Auth.signIn(this.email, this.password).then(response => {
        this.user = response;
      });
    } else if (this.mode === 'sms-verify') {
      this.userService.beginSmsVerification().subscribe(() => {
        this.verificationCodeSent = true;
      })
    }
  }

  closeDialog(): void {
    this.dialogRef.close(false);
  }

  submitOtp(): void {
    if (this.mode === 'verify-phone') {
      Auth.verifyCurrentUserAttributeSubmit('phone_number', this.otpForm.value.otp).then(
        () => {
          this.errorMessage = undefined;
          this.dialogRef.close(true);
        },
        error => {
          this.errorMessage = error.message;
          console.log(error);
        }
      );
    } else if (this.mode === 'sms-verify') {
      this.userService.checkSmsVerification(this.otpForm.value.otp).subscribe({
        next: () => {
          this.errorMessage = undefined;
          this.dialogRef.close(true);
        },
        error: error => {
          this.errorMessage = error.message;
        }
      });
    } else {
      Auth.confirmSignIn(this.user, this.otpForm.value.otp, 'SMS_MFA')
        .then(response => {
          this.errorMessage = undefined;
          this.dialogRef.close(response);
        })
        .catch(error => {
          this.errorMessage = error.message;
          console.log(error);
        });
    }
  }
}
